import { render, staticRenderFns } from "./ServiceBadgesV2026.vue?vue&type=template&id=3586b0d7&scoped=true"
import script from "./ServiceBadgesV2026.vue?vue&type=script&lang=js"
export * from "./ServiceBadgesV2026.vue?vue&type=script&lang=js"
import style0 from "./ServiceBadgesV2026.vue?vue&type=style&index=0&id=3586b0d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3586b0d7",
  null
  
)

export default component.exports